<template>
  <div class="page-wrapper" >
    <Tabs  v-model="current" >

      <TabPane name="1" label="经营看板" v-if="p('management/cards')">
        <c1></c1>
      </TabPane>
      <TabPane name="2" label="成本明细" v-if="p('incomeCostItem/cost/list')">
        <c2></c2>
      </TabPane>
      <TabPane name="3" label="收入明细" v-if="p('incomeCostItem/income/list')">
        <c3></c3>
      </TabPane>
      <TabPane name="4" label="水电抄表记录" v-if="p('waterwatt/ordinary/haveRead')">
        <c4></c4>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
  import C1 from '@/views/incomManager/dashBoard/index'

  import C2 from '@/views/incomManager/cost/index'
  import C3 from '@/views/incomManager/income/index'
  import C4 from '@/views/smartPower/waterAndElectricityRecord/index'
  import {mixin} from "../../mixin";

  export default {
    name:'operateboard',
    mixins:[mixin],
    components:{
      C1,
      C2,
      C3,
      C4,

    }        ,
    data(){
      return {
        current:null
      }
    }

  }
</script>

<style scoped>

</style>
